import {ConstantsParser} from "../../../ConstantsParser";
import {StylesParser} from "../../../StylesParser";

export class Secondary {
  constructor() {
    this.name = 'Secondary'
    this.content = {
      hasIcon: true,
      hasText: false,
      text: "Example Text",
      class: 'fas',
      icon: 'fa-cube'
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let containerClasses = (new ConstantsParser(this.containerClasses())).parse().join(' ')
    let styles = (new StylesParser(this.styles())).parse()
    styles = Object.keys(styles).map(variationStyle => `${variationStyle}:${styles[variationStyle]}`).join(';')

    return `<div
      style="${styles}"
      ><div class="${containerClasses}">With Icon</div></div>`;
  }

  classes() {
    return []
  }

  styles() {
    return [
      {property:'BorderColor', styleProperty: 'border-color', value: 'rgba(138.24,115.2,115.2, 1)'}
    ]
  }

  containerClasses() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'AlignItems', 'value': 'ALIGN_ITEMS_CENTER'},
      {property: 'FontSize', value: 'FONT_SIZE_BASE'},
    ]
  }

  contentClasses() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'AlignItems', 'value': 'ALIGN_ITEMS_CENTER'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_NORMAL'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_NORMAL'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_NORMAL'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_NORMAL'},
    ]
  }

  iconContainerClasses() {
    return [
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
    ]
  }

  iconClasses() {
    return [
      { property: 'IconSize', value: 'ICON_SIZE_2X' }
    ]
  }

  iconStyles() {
    return [
      { property: 'TextColor', styleProperty: 'color', value: 'rgba(20,90,253,1)'}
    ]
  }

  iconContainerStyles() {
    return [
      { property: 'TextColor', styleProperty: 'color', value: 'rgba(20,90,253,1)'}
    ]
  }

  textClasses() {
    return [
      {property: 'FontWeight', value: 'NORMAL'},
      {property: 'PaddingRight', value: 'PADDING_RIGHT_XS'},
      {property: 'PaddingLeft', value: 'PADDING_LEFT_XS'},
    ]
  }

  textStyles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses(),
      },
      contentClasses: {
        desktop: this.contentClasses(),
        tablet: this.contentClasses(),
        phone: this.contentClasses(),
      },
      iconContainerClasses: {
        desktop: this.iconContainerClasses(),
        tablet: this.iconContainerClasses(),
        phone: this.iconContainerClasses(),
      },
      iconClasses: {
        desktop: this.iconClasses(),
        tablet: this.iconClasses(),
        phone: this.iconClasses(),
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      iconContainerStyles: {
        desktop: this.iconContainerStyles(),
        tablet: this.iconContainerStyles(),
        phone: this.iconContainerStyles()
      },

      textClasses: {
        desktop: this.textClasses(),
        tablet: this.textClasses(),
        phone: this.textClasses()
      },
      textStyles: {
        desktop: this.textStyles(),
        tablet: this.textStyles(),
        phone: this.textStyles()
      },
    }
  }
}
